module.exports = __webpack_public_path__ + "img/404.fc372a85.jpg";